import React, { useState, useEffect } from 'react';

//components
import { Accordion, HeadTabs } from "../../storyboard/common";
import { DragQuestion } from "../../storyboard/Question";

//redux
import { useSelector } from "react-redux";

//reactstrap
import { TabContent, TabPane } from "reactstrap";

//utils
import { LoaderText } from "@utils";

//RichTextCommon
import RichTextCommon from "../RichTextCommon";

function ActionsMain(props) {
    //props
    const {
        value,
        activeTabCt,
        listTabs,
        handleUpdateEditor,
        valueEditor,
        timePointId,
        filterQuestionForTask
    } = props && props;

    //state
    const [heightPatientMedRecord, setHeightPatientMedRecord] = useState(0);

    // Check tồn tại và lấy height của #erm-nomarl-screen và #erm-full-screen
    useEffect(() => {
        const normalEl = document.getElementById("erm-nomarl-screen");
        const fullEl = document.getElementById("erm-full-screen");

        if (normalEl) {
            setHeightPatientMedRecord(normalEl.clientHeight);
        } else if (fullEl) {
            setHeightPatientMedRecord(fullEl.clientHeight);
        } else {
            console.warn('Không tìm thấy element với id="erm-nomarl-screen" hoặc "erm-full-screen"');
        }
    }, []); // chạy 1 lần sau khi mount

    //store
    const actionsData = useSelector((state) => state.loadActionsTarget || []);
    return (
        <React.Fragment>
            <HeadTabs
                {...props}
                title={value.Label}
                task='actions'
            />
            <TabContent activeTab={activeTabCt}>
                {listTabs?.actions.map(
                    (item, index) =>
                        item.show && (
                            <TabPane key={index} tabId={`${index + 1}`}>
                                {item.id === "1" && (
                                    <React.Fragment>
                                        {actionsData?.isLoading && <div style={{ height: '300px' }}><LoaderText /></div>}
                                        {!actionsData?.isLoading && (
                                            <Accordion
                                                {...props}
                                                categoryType={`Action`}
                                                data={actionsData?.data || []}
                                                heightPatientMedRecord={heightPatientMedRecord}
                                            />
                                        )}
                                    </React.Fragment>
                                )}
                                {item.id === "2" && (
                                    <RichTextCommon
                                        handleUpdateEditor={handleUpdateEditor}
                                        task={value?.ViewClass}
                                        defaultValue={valueEditor?.actions}
                                        placeholder="Enter the instructions for the learner here..."
                                        timePointId={timePointId}
                                        heightPatientMedRecord={heightPatientMedRecord}
                                    />
                                )}
                                {item.id === "3" && (
                                    <DragQuestion
                                        {...props}
                                        task={value.ViewClass}
                                        data={filterQuestionForTask(value.ViewClass)}
                                        heightPatientMedRecord={heightPatientMedRecord}
                                    />
                                )}
                            </TabPane>
                        )
                )}
            </TabContent>
        </React.Fragment>
    );
};

export default ActionsMain;